
import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS } from '@angular/forms';
import { CpfCnpjValidator } from '../validators/cpfCnpjValidator';


@Directive({
selector: '[appCpfCnpjValidate][ngModel]',
providers: [{
provide: NG_VALIDATORS,
useExisting: cpfCnpjValidatorDirective,
multi: true
}]
})
export class cpfCnpjValidatorDirective extends CpfCnpjValidator implements Validator {}